import { render, staticRenderFns } from "./Fopag.vue?vue&type=template&id=66dc6592&scoped=true&"
import script from "./Fopag.vue?vue&type=script&lang=js&"
export * from "./Fopag.vue?vue&type=script&lang=js&"
import style0 from "./Fopag.vue?vue&type=style&index=0&id=66dc6592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc6592",
  null
  
)

export default component.exports